// @ts-strict-ignore
import React from "react";
import UserCircle from "app/components/Icons/CircleUser";
import withStyles from "isomorphic-style-loader/withStyles";
import classes from "./style.scss";
import { UserProp } from "app/GraphqlGeneratedTypes/types";

interface Props {
	user: UserProp & { avatar: string };
	setIsAvatarOnFocus: (value) => void;
}

const Avatar : React.FC<Props> = ({
	user,
	setIsAvatarOnFocus
}) => {
	const initials = user?.firstName?.charAt(0) + user?.lastName?.charAt(0);

	const mouseOverHandler = () => {
		if (setIsAvatarOnFocus) {
			setIsAvatarOnFocus((value) => !value);
		}
	};
	const getLoggedInAvatar = (activeUser) => {
		return activeUser.avatar
			? <div className={classes.circle} style={{ backgroundImage: `url(${user.avatar})` }} />
			: <div className={classes.circle} style={{ background: "#58595c" }}>{initials}</div>;
	};

	return (
		<div
			data-test-id="avatar"
			data-cy="avatar"
			className={classes.userAvatar}
			onMouseOver={mouseOverHandler}
			onMouseLeave={mouseOverHandler}
		>
			{
				user
					? getLoggedInAvatar(user)
					: (
						<div className={classes.circle}>
							<UserCircle />
						</div>
					)
			}
		</div>
	);
};

export default withStyles(classes)(Avatar);
